import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useCustomModel } from "components/context/CustomProvider";
import { useNiceModalLocker } from "components/context/NiceModalProvider";
import CustomDialog from "../CustomDialog";
import CustomForm from "../forms/CustomForm";

const ObjectUpdateModal = (modelName) => {
  if (!modelName) {
    throw new Error("ModelUpdateModal requires a modelName");
  }

  return NiceModal.create(({ obj, submitter, deletter, errors }) => {
    const modal = useModal();
    const model = useCustomModel(modelName);
    const { locked, setLocked, closeFormIfNotLocked, forceClose } =
      useNiceModalLocker(modal);

    const data = obj;

    return (
      <CustomDialog
        variant="dialog"
        open={modal.visible}
        onClose={closeFormIfNotLocked}
      >
        <CustomForm
          title={`Update ${model.modelName}${locked ? " (Locked)" : ""}`}
          defaultValues={data}
          fields={model.fields}
          submitter={submitter}
          deleter={deletter}
          onDone={modal.hide}
          onDeleted={modal.hide}
          onCancel={forceClose}
          onIsDirty={setLocked}
          modelName={modelName}
          errors={errors}
        />
      </CustomDialog>
    );
  });
};

export default ObjectUpdateModal;
